/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  ErrorDescription,
  GetVisitsParams,
  MessageApiContract,
  PatientVisitListItemStaffApiOutContract,
  PhoneCallAccessTokenDoctorApiOutContract,
  VisitCollectionItemDoctorApiOutContractPaginationItemCollectionApiOutContract,
  VisitDoctorApiOutContract,
  VisitIcdCodeCollectionDoctorApiInContract,
  VisitMedicalRecordApiOutContract,
  VisitRatingApiInContract,
  VisitRemarkStaffApiOutContract,
  VisitVideoDoctorApiOutContract,
  WaitingRoomVisitListItemDoctorApiOutContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getVisitsWaitingroom = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<WaitingRoomVisitListItemDoctorApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/waitingroom`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVisitsWaitingroomInfiniteQueryKey = () => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/visits/waitingroom`
    ] as const;
    }

export const getGetVisitsWaitingroomQueryKey = () => {
    return [
    `https://providers-api.api.quick.md/api/v1/visits/waitingroom`
    ] as const;
    }

    
export const getGetVisitsWaitingroomInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroom>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsWaitingroomInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsWaitingroom>>> = ({ signal }) => getVisitsWaitingroom(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsWaitingroomInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsWaitingroom>>>
export type GetVisitsWaitingroomInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsWaitingroomInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroom>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsWaitingroom>>,
          TError,
          Awaited<ReturnType<typeof getVisitsWaitingroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroom>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsWaitingroom>>,
          TError,
          Awaited<ReturnType<typeof getVisitsWaitingroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroom>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsWaitingroomInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroom>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsWaitingroomInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsWaitingroomInfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsWaitingroomInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsWaitingroomQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsWaitingroomQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsWaitingroom>>> = ({ signal }) => getVisitsWaitingroom(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsWaitingroomQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsWaitingroom>>>
export type GetVisitsWaitingroomQueryError = void | ErrorApiOutContract


export function useGetVisitsWaitingroom<TData = Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsWaitingroom>>,
          TError,
          Awaited<ReturnType<typeof getVisitsWaitingroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroom<TData = Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsWaitingroom>>,
          TError,
          Awaited<ReturnType<typeof getVisitsWaitingroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroom<TData = Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsWaitingroom<TData = Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsWaitingroomQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsWaitingroomQuery = async <TData = Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsWaitingroomQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsWaitingroomSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsWaitingroomQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsWaitingroom>>> = ({ signal }) => getVisitsWaitingroom(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsWaitingroomSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsWaitingroom>>>
export type GetVisitsWaitingroomSuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsWaitingroomSuspense<TData = Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomSuspense<TData = Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomSuspense<TData = Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsWaitingroomSuspense<TData = Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsWaitingroomSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsWaitingroomSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroom>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsWaitingroomInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsWaitingroom>>> = ({ signal }) => getVisitsWaitingroom(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsWaitingroomSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsWaitingroom>>>
export type GetVisitsWaitingroomSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsWaitingroomSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroom>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroom>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroom>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsWaitingroomSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroom>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroom>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsWaitingroomSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * # Possible Errors
| HTTP status | ErrorCode         | Description                                              |
|-------------|-------------------|----------------------------------------------------------|
| 401         | Unauthorized      | Authentication is required to access this resource.     |
| 404         | VisitNotFound     | The visit with the specified ID could not be found.     |
| 500         | InternalServerError | An unexpected error occurred on the server side.      |
 * @summary Retrieves information related to a specific visit.
 */
export const getVisitsVisitId = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<VisitDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVisitsVisitIdInfiniteQueryKey = (visitId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/visits/${visitId}`
    ] as const;
    }

export const getGetVisitsVisitIdQueryKey = (visitId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/visits/${visitId}`
    ] as const;
    }

    
export const getGetVisitsVisitIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitId>>> = ({ signal }) => getVisitsVisitId(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitId>>>
export type GetVisitsVisitIdInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitId>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitId>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves information related to a specific visit.
 */

export function useGetVisitsVisitIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdInfiniteQueryOptions(visitId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves information related to a specific visit.
 */
export const prefetchGetVisitsVisitIdInfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdInfiniteQueryOptions(visitId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitId>>> = ({ signal }) => getVisitsVisitId(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitId>>>
export type GetVisitsVisitIdQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitId<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitId>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitId<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitId>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitId<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves information related to a specific visit.
 */

export function useGetVisitsVisitId<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdQueryOptions(visitId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves information related to a specific visit.
 */
export const prefetchGetVisitsVisitIdQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdQueryOptions(visitId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitId>>> = ({ signal }) => getVisitsVisitId(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitId>>>
export type GetVisitsVisitIdSuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves information related to a specific visit.
 */

export function useGetVisitsVisitIdSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitId>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdSuspenseQueryOptions(visitId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsVisitIdSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitId>>> = ({ signal }) => getVisitsVisitId(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitId>>>
export type GetVisitsVisitIdSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves information related to a specific visit.
 */

export function useGetVisitsVisitIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitId>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdSuspenseInfiniteQueryOptions(visitId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putVisitsVisitIdEnd = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/end`, method: 'PUT'
    },
      options);
    }
  


export const getPutVisitsVisitIdEndMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdEnd>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdEnd>>, TError,{visitId: string}, TContext> => {

const mutationKey = ['putVisitsVisitIdEnd'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVisitsVisitIdEnd>>, {visitId: string}> = (props) => {
          const {visitId} = props ?? {};

          return  putVisitsVisitIdEnd(visitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVisitsVisitIdEndMutationResult = NonNullable<Awaited<ReturnType<typeof putVisitsVisitIdEnd>>>
    
    export type PutVisitsVisitIdEndMutationError = void | ErrorApiOutContract

    export const usePutVisitsVisitIdEnd = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdEnd>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVisitsVisitIdEnd>>,
        TError,
        {visitId: string},
        TContext
      > => {

      const mutationOptions = getPutVisitsVisitIdEndMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putVisitsVisitIdUnresolve = (
    visitId: string,
    messageApiContract: MessageApiContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/unresolve`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: messageApiContract
    },
      options);
    }
  


export const getPutVisitsVisitIdUnresolveMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdUnresolve>>, TError,{visitId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdUnresolve>>, TError,{visitId: string;data: MessageApiContract}, TContext> => {

const mutationKey = ['putVisitsVisitIdUnresolve'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVisitsVisitIdUnresolve>>, {visitId: string;data: MessageApiContract}> = (props) => {
          const {visitId,data} = props ?? {};

          return  putVisitsVisitIdUnresolve(visitId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVisitsVisitIdUnresolveMutationResult = NonNullable<Awaited<ReturnType<typeof putVisitsVisitIdUnresolve>>>
    export type PutVisitsVisitIdUnresolveMutationBody = MessageApiContract
    export type PutVisitsVisitIdUnresolveMutationError = void | ErrorApiOutContract

    export const usePutVisitsVisitIdUnresolve = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdUnresolve>>, TError,{visitId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVisitsVisitIdUnresolve>>,
        TError,
        {visitId: string;data: MessageApiContract},
        TContext
      > => {

      const mutationOptions = getPutVisitsVisitIdUnresolveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putVisitsVisitIdComplete = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/complete`, method: 'PUT'
    },
      options);
    }
  


export const getPutVisitsVisitIdCompleteMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdComplete>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdComplete>>, TError,{visitId: string}, TContext> => {

const mutationKey = ['putVisitsVisitIdComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVisitsVisitIdComplete>>, {visitId: string}> = (props) => {
          const {visitId} = props ?? {};

          return  putVisitsVisitIdComplete(visitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVisitsVisitIdCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof putVisitsVisitIdComplete>>>
    
    export type PutVisitsVisitIdCompleteMutationError = void | ErrorApiOutContract

    export const usePutVisitsVisitIdComplete = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdComplete>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVisitsVisitIdComplete>>,
        TError,
        {visitId: string},
        TContext
      > => {

      const mutationOptions = getPutVisitsVisitIdCompleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putVisitsVisitIdBackinwaitingroom = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/backinwaitingroom`, method: 'PUT'
    },
      options);
    }
  


export const getPutVisitsVisitIdBackinwaitingroomMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdBackinwaitingroom>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdBackinwaitingroom>>, TError,{visitId: string}, TContext> => {

const mutationKey = ['putVisitsVisitIdBackinwaitingroom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVisitsVisitIdBackinwaitingroom>>, {visitId: string}> = (props) => {
          const {visitId} = props ?? {};

          return  putVisitsVisitIdBackinwaitingroom(visitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVisitsVisitIdBackinwaitingroomMutationResult = NonNullable<Awaited<ReturnType<typeof putVisitsVisitIdBackinwaitingroom>>>
    
    export type PutVisitsVisitIdBackinwaitingroomMutationError = void | ErrorApiOutContract

    export const usePutVisitsVisitIdBackinwaitingroom = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdBackinwaitingroom>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVisitsVisitIdBackinwaitingroom>>,
        TError,
        {visitId: string},
        TContext
      > => {

      const mutationOptions = getPutVisitsVisitIdBackinwaitingroomMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The visit is assigned to the calling provider and marked in progress; it is removed from the other
eligible providers' waiting rooms in real time. Only a provider licensed for the visit's state and visit type
may claim it, and concurrent claims resolve to a single winner.
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 403 | Forbidden | The provider is not licensed for the visit's state and visit type |
| 404 | VisitNotFound | The visit could not be found or is not an asynchronous visit |
| 409 | VisitAlreadyClaimed | The visit has already been claimed by another provider |
 * @summary Claims an unassigned asynchronous visit for the calling provider.
 */
export const putVisitsVisitIdClaim = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/claim`, method: 'PUT'
    },
      options);
    }
  


export const getPutVisitsVisitIdClaimMutationOptions = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdClaim>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdClaim>>, TError,{visitId: string}, TContext> => {

const mutationKey = ['putVisitsVisitIdClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVisitsVisitIdClaim>>, {visitId: string}> = (props) => {
          const {visitId} = props ?? {};

          return  putVisitsVisitIdClaim(visitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVisitsVisitIdClaimMutationResult = NonNullable<Awaited<ReturnType<typeof putVisitsVisitIdClaim>>>
    
    export type PutVisitsVisitIdClaimMutationError = void | ErrorDescription | ErrorApiOutContract

    /**
 * @summary Claims an unassigned asynchronous visit for the calling provider.
 */
export const usePutVisitsVisitIdClaim = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdClaim>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVisitsVisitIdClaim>>,
        TError,
        {visitId: string},
        TContext
      > => {

      const mutationOptions = getPutVisitsVisitIdClaimMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The visit is unassigned from the provider and returned to the unassigned pool (scheduled-by-patient), so it
reappears in the eligible providers' waiting rooms in real time. Only the provider the visit is currently
assigned to may unclaim it.
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 403 | Forbidden | The visit is not currently assigned to the calling provider |
| 404 | VisitNotFound | The visit could not be found or is not an asynchronous visit |
| 409 | VisitNotClaimed | The visit is no longer in a claimed state and cannot be released |
 * @summary Unclaims (releases) an asynchronous visit currently assigned to the calling provider.
 */
export const putVisitsVisitIdUnclaim = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/unclaim`, method: 'PUT'
    },
      options);
    }
  


export const getPutVisitsVisitIdUnclaimMutationOptions = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdUnclaim>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdUnclaim>>, TError,{visitId: string}, TContext> => {

const mutationKey = ['putVisitsVisitIdUnclaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVisitsVisitIdUnclaim>>, {visitId: string}> = (props) => {
          const {visitId} = props ?? {};

          return  putVisitsVisitIdUnclaim(visitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVisitsVisitIdUnclaimMutationResult = NonNullable<Awaited<ReturnType<typeof putVisitsVisitIdUnclaim>>>
    
    export type PutVisitsVisitIdUnclaimMutationError = void | ErrorDescription | ErrorApiOutContract

    /**
 * @summary Unclaims (releases) an asynchronous visit currently assigned to the calling provider.
 */
export const usePutVisitsVisitIdUnclaim = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdUnclaim>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVisitsVisitIdUnclaim>>,
        TError,
        {visitId: string},
        TContext
      > => {

      const mutationOptions = getPutVisitsVisitIdUnclaimMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVisits = (
    params?: GetVisitsParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<VisitCollectionItemDoctorApiOutContractPaginationItemCollectionApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/visits`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetVisitsInfiniteQueryKey = (params?: GetVisitsParams,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/visits`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetVisitsQueryKey = (params?: GetVisitsParams,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/visits`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetVisitsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(params?: GetVisitsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisits>>> = ({ signal }) => getVisits(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisits>>>
export type GetVisitsInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisits>>,
          TError,
          Awaited<ReturnType<typeof getVisits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisits>>,
          TError,
          Awaited<ReturnType<typeof getVisits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetVisitsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsQueryOptions = <TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(params?: GetVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisits>>> = ({ signal }) => getVisits(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsQueryResult = NonNullable<Awaited<ReturnType<typeof getVisits>>>
export type GetVisitsQueryError = void | ErrorApiOutContract


export function useGetVisits<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisits>>,
          TError,
          Awaited<ReturnType<typeof getVisits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisits<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisits>>,
          TError,
          Awaited<ReturnType<typeof getVisits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisits<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisits<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsQuery = async <TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisits>>> = ({ signal }) => getVisits(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisits>>>
export type GetVisitsSuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsSuspense<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsSuspense<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsSuspense<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsSuspense<TData = Awaited<ReturnType<typeof getVisits>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisits>>> = ({ signal }) => getVisits(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisits>>>
export type GetVisitsSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisits>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisits>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPatientsPatientIdVisitsPast = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientVisitListItemStaffApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/visits/past`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdVisitsPastInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/visits/past`
    ] as const;
    }

export const getGetPatientsPatientIdVisitsPastQueryKey = (patientId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/visits/past`
    ] as const;
    }

    
export const getGetPatientsPatientIdVisitsPastInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsPastInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>> = ({ signal }) => getPatientsPatientIdVisitsPast(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsPastInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>
export type GetPatientsPatientIdVisitsPastInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsPastInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPastInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPastInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsPastInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsPastInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdVisitsPastInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdVisitsPastInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdVisitsPastQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsPastQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>> = ({ signal }) => getPatientsPatientIdVisitsPast(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsPastQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>
export type GetPatientsPatientIdVisitsPastQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsPast<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPast<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPast<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsPast<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsPastQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdVisitsPastQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdVisitsPastQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdVisitsPastSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsPastQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>> = ({ signal }) => getPatientsPatientIdVisitsPast(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsPastSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>
export type GetPatientsPatientIdVisitsPastSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsPastSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPastSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPastSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsPastSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsPastSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdVisitsPastSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsPastInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>> = ({ signal }) => getPatientsPatientIdVisitsPast(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsPastSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>
export type GetPatientsPatientIdVisitsPastSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsPastSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPastSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsPastSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsPastSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsPast>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsPastSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPatientsPatientIdVisitsUpcoming = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientVisitListItemStaffApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/visits/upcoming`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdVisitsUpcomingInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/visits/upcoming`
    ] as const;
    }

export const getGetPatientsPatientIdVisitsUpcomingQueryKey = (patientId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/visits/upcoming`
    ] as const;
    }

    
export const getGetPatientsPatientIdVisitsUpcomingInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsUpcomingInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>> = ({ signal }) => getPatientsPatientIdVisitsUpcoming(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsUpcomingInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>
export type GetPatientsPatientIdVisitsUpcomingInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsUpcomingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcomingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcomingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsUpcomingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsUpcomingInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdVisitsUpcomingInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdVisitsUpcomingInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdVisitsUpcomingQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsUpcomingQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>> = ({ signal }) => getPatientsPatientIdVisitsUpcoming(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsUpcomingQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>
export type GetPatientsPatientIdVisitsUpcomingQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsUpcoming<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcoming<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcoming<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsUpcoming<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsUpcomingQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdVisitsUpcomingQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdVisitsUpcomingQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdVisitsUpcomingSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsUpcomingQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>> = ({ signal }) => getPatientsPatientIdVisitsUpcoming(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsUpcomingSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>
export type GetPatientsPatientIdVisitsUpcomingSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsUpcomingSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcomingSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcomingSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsUpcomingSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsUpcomingSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdVisitsUpcomingSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitsUpcomingInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>> = ({ signal }) => getPatientsPatientIdVisitsUpcoming(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitsUpcomingSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>
export type GetPatientsPatientIdVisitsUpcomingSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitsUpcomingSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcomingSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitsUpcomingSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdVisitsUpcomingSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitsUpcoming>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitsUpcomingSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postVisitsVisitIdInperson = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/inperson`, method: 'POST', signal
    },
      options);
    }
  


export const getPostVisitsVisitIdInpersonMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdInperson>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdInperson>>, TError,{visitId: string}, TContext> => {

const mutationKey = ['postVisitsVisitIdInperson'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVisitsVisitIdInperson>>, {visitId: string}> = (props) => {
          const {visitId} = props ?? {};

          return  postVisitsVisitIdInperson(visitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVisitsVisitIdInpersonMutationResult = NonNullable<Awaited<ReturnType<typeof postVisitsVisitIdInperson>>>
    
    export type PostVisitsVisitIdInpersonMutationError = void | ErrorApiOutContract

    export const usePostVisitsVisitIdInperson = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdInperson>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVisitsVisitIdInperson>>,
        TError,
        {visitId: string},
        TContext
      > => {

      const mutationOptions = getPostVisitsVisitIdInpersonMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | ThirdPartyError | Error on third party side. See info in Data object |
| 401 |  |  |
| 403 | Forbidden | See preconditions in description |
| 404 | VisitNotFound | The visit is not found or doesn't belong to the current doctor |
| 500 | InternalServerError | Internal server error |
 * @summary Initiates a video visit call for a visit
 */
export const postVisitsVisitIdVideo = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<VisitVideoDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/video`, method: 'POST', signal
    },
      options);
    }
  


export const getPostVisitsVisitIdVideoMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdVideo>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdVideo>>, TError,{visitId: string}, TContext> => {

const mutationKey = ['postVisitsVisitIdVideo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVisitsVisitIdVideo>>, {visitId: string}> = (props) => {
          const {visitId} = props ?? {};

          return  postVisitsVisitIdVideo(visitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVisitsVisitIdVideoMutationResult = NonNullable<Awaited<ReturnType<typeof postVisitsVisitIdVideo>>>
    
    export type PostVisitsVisitIdVideoMutationError = void | ErrorApiOutContract

    /**
 * @summary Initiates a video visit call for a visit
 */
export const usePostVisitsVisitIdVideo = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdVideo>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVisitsVisitIdVideo>>,
        TError,
        {visitId: string},
        TContext
      > => {

      const mutationOptions = getPostVisitsVisitIdVideoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteVisitsVisitIdVideo = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/video`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteVisitsVisitIdVideoMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdVideo>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdVideo>>, TError,{visitId: string}, TContext> => {

const mutationKey = ['deleteVisitsVisitIdVideo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVisitsVisitIdVideo>>, {visitId: string}> = (props) => {
          const {visitId} = props ?? {};

          return  deleteVisitsVisitIdVideo(visitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVisitsVisitIdVideoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVisitsVisitIdVideo>>>
    
    export type DeleteVisitsVisitIdVideoMutationError = void | ErrorApiOutContract

    export const useDeleteVisitsVisitIdVideo = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdVideo>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVisitsVisitIdVideo>>,
        TError,
        {visitId: string},
        TContext
      > => {

      const mutationOptions = getDeleteVisitsVisitIdVideoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
| HTTP status | ErrorCode           | Description                                              |
|-------------|---------------------|----------------------------------------------------------|
| 404         | VisitNotFound       | The visit is not found or doesn't belong to the current doctor |
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */
export const getVisitsVisitIdCallToken = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PhoneCallAccessTokenDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/call/token`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVisitsVisitIdCallTokenInfiniteQueryKey = (visitId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/visits/${visitId}/call/token`
    ] as const;
    }

export const getGetVisitsVisitIdCallTokenQueryKey = (visitId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/visits/${visitId}/call/token`
    ] as const;
    }

    
export const getGetVisitsVisitIdCallTokenInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdCallTokenInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>> = ({ signal }) => getVisitsVisitIdCallToken(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdCallTokenInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>
export type GetVisitsVisitIdCallTokenInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdCallTokenInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */

export function useGetVisitsVisitIdCallTokenInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdCallTokenInfiniteQueryOptions(visitId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */
export const prefetchGetVisitsVisitIdCallTokenInfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdCallTokenInfiniteQueryOptions(visitId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdCallTokenQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdCallTokenQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>> = ({ signal }) => getVisitsVisitIdCallToken(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdCallTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>
export type GetVisitsVisitIdCallTokenQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdCallToken<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallToken<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallToken<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */

export function useGetVisitsVisitIdCallToken<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdCallTokenQueryOptions(visitId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */
export const prefetchGetVisitsVisitIdCallTokenQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdCallTokenQueryOptions(visitId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdCallTokenSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdCallTokenQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>> = ({ signal }) => getVisitsVisitIdCallToken(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdCallTokenSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>
export type GetVisitsVisitIdCallTokenSuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdCallTokenSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */

export function useGetVisitsVisitIdCallTokenSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdCallTokenSuspenseQueryOptions(visitId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsVisitIdCallTokenSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdCallTokenInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>> = ({ signal }) => getVisitsVisitIdCallToken(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdCallTokenSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>
export type GetVisitsVisitIdCallTokenSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdCallTokenSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */

export function useGetVisitsVisitIdCallTokenSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallToken>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdCallTokenSuspenseInfiniteQueryOptions(visitId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVisitsVisitIdRemarks = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<VisitRemarkStaffApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/remarks`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVisitsVisitIdRemarksInfiniteQueryKey = (visitId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/visits/${visitId}/remarks`
    ] as const;
    }

export const getGetVisitsVisitIdRemarksQueryKey = (visitId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/visits/${visitId}/remarks`
    ] as const;
    }

    
export const getGetVisitsVisitIdRemarksInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdRemarksInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>> = ({ signal }) => getVisitsVisitIdRemarks(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdRemarksInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>
export type GetVisitsVisitIdRemarksInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdRemarksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdRemarksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdRemarksInfiniteQueryOptions(visitId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsVisitIdRemarksInfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdRemarksInfiniteQueryOptions(visitId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdRemarksQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdRemarksQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>> = ({ signal }) => getVisitsVisitIdRemarks(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdRemarksQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>
export type GetVisitsVisitIdRemarksQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdRemarks<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarks<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarks<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdRemarks<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdRemarksQueryOptions(visitId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsVisitIdRemarksQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdRemarksQueryOptions(visitId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdRemarksSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdRemarksQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>> = ({ signal }) => getVisitsVisitIdRemarks(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdRemarksSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>
export type GetVisitsVisitIdRemarksSuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdRemarksSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarksSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarksSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdRemarksSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdRemarksSuspenseQueryOptions(visitId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsVisitIdRemarksSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdRemarksInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>> = ({ signal }) => getVisitsVisitIdRemarks(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdRemarksSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>
export type GetVisitsVisitIdRemarksSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdRemarksSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarksSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdRemarksSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdRemarksSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdRemarks>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdRemarksSuspenseInfiniteQueryOptions(visitId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postVisitsVisitIdRemarks = (
    visitId: string,
    messageApiContract: MessageApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<VisitRemarkStaffApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/remarks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: messageApiContract, signal
    },
      options);
    }
  


export const getPostVisitsVisitIdRemarksMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdRemarks>>, TError,{visitId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdRemarks>>, TError,{visitId: string;data: MessageApiContract}, TContext> => {

const mutationKey = ['postVisitsVisitIdRemarks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVisitsVisitIdRemarks>>, {visitId: string;data: MessageApiContract}> = (props) => {
          const {visitId,data} = props ?? {};

          return  postVisitsVisitIdRemarks(visitId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVisitsVisitIdRemarksMutationResult = NonNullable<Awaited<ReturnType<typeof postVisitsVisitIdRemarks>>>
    export type PostVisitsVisitIdRemarksMutationBody = MessageApiContract
    export type PostVisitsVisitIdRemarksMutationError = void | ErrorApiOutContract

    export const usePostVisitsVisitIdRemarks = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdRemarks>>, TError,{visitId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVisitsVisitIdRemarks>>,
        TError,
        {visitId: string;data: MessageApiContract},
        TContext
      > => {

      const mutationOptions = getPostVisitsVisitIdRemarksMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putVisitsVisitIdRemarksRemarkId = (
    visitId: string,
    remarkId: string,
    messageApiContract: MessageApiContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<VisitRemarkStaffApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/remarks/${encodeURIComponent(String(remarkId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: messageApiContract
    },
      options);
    }
  


export const getPutVisitsVisitIdRemarksRemarkIdMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdRemarksRemarkId>>, TError,{visitId: string;remarkId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdRemarksRemarkId>>, TError,{visitId: string;remarkId: string;data: MessageApiContract}, TContext> => {

const mutationKey = ['putVisitsVisitIdRemarksRemarkId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVisitsVisitIdRemarksRemarkId>>, {visitId: string;remarkId: string;data: MessageApiContract}> = (props) => {
          const {visitId,remarkId,data} = props ?? {};

          return  putVisitsVisitIdRemarksRemarkId(visitId,remarkId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVisitsVisitIdRemarksRemarkIdMutationResult = NonNullable<Awaited<ReturnType<typeof putVisitsVisitIdRemarksRemarkId>>>
    export type PutVisitsVisitIdRemarksRemarkIdMutationBody = MessageApiContract
    export type PutVisitsVisitIdRemarksRemarkIdMutationError = void | ErrorApiOutContract

    export const usePutVisitsVisitIdRemarksRemarkId = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdRemarksRemarkId>>, TError,{visitId: string;remarkId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVisitsVisitIdRemarksRemarkId>>,
        TError,
        {visitId: string;remarkId: string;data: MessageApiContract},
        TContext
      > => {

      const mutationOptions = getPutVisitsVisitIdRemarksRemarkIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteVisitsVisitIdRemarksRemarkId = (
    visitId: string,
    remarkId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/remarks/${encodeURIComponent(String(remarkId))}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteVisitsVisitIdRemarksRemarkIdMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdRemarksRemarkId>>, TError,{visitId: string;remarkId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdRemarksRemarkId>>, TError,{visitId: string;remarkId: string}, TContext> => {

const mutationKey = ['deleteVisitsVisitIdRemarksRemarkId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVisitsVisitIdRemarksRemarkId>>, {visitId: string;remarkId: string}> = (props) => {
          const {visitId,remarkId} = props ?? {};

          return  deleteVisitsVisitIdRemarksRemarkId(visitId,remarkId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVisitsVisitIdRemarksRemarkIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVisitsVisitIdRemarksRemarkId>>>
    
    export type DeleteVisitsVisitIdRemarksRemarkIdMutationError = void | ErrorApiOutContract

    export const useDeleteVisitsVisitIdRemarksRemarkId = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdRemarksRemarkId>>, TError,{visitId: string;remarkId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVisitsVisitIdRemarksRemarkId>>,
        TError,
        {visitId: string;remarkId: string},
        TContext
      > => {

      const mutationOptions = getDeleteVisitsVisitIdRemarksRemarkIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postVisitsVisitIdNotes = (
    visitId: string,
    messageApiContract: MessageApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<VisitMedicalRecordApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/notes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: messageApiContract, signal
    },
      options);
    }
  


export const getPostVisitsVisitIdNotesMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdNotes>>, TError,{visitId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdNotes>>, TError,{visitId: string;data: MessageApiContract}, TContext> => {

const mutationKey = ['postVisitsVisitIdNotes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVisitsVisitIdNotes>>, {visitId: string;data: MessageApiContract}> = (props) => {
          const {visitId,data} = props ?? {};

          return  postVisitsVisitIdNotes(visitId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVisitsVisitIdNotesMutationResult = NonNullable<Awaited<ReturnType<typeof postVisitsVisitIdNotes>>>
    export type PostVisitsVisitIdNotesMutationBody = MessageApiContract
    export type PostVisitsVisitIdNotesMutationError = void | ErrorApiOutContract

    export const usePostVisitsVisitIdNotes = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdNotes>>, TError,{visitId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVisitsVisitIdNotes>>,
        TError,
        {visitId: string;data: MessageApiContract},
        TContext
      > => {

      const mutationOptions = getPostVisitsVisitIdNotesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteVisitsVisitIdNotes = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/notes`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteVisitsVisitIdNotesMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdNotes>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdNotes>>, TError,{visitId: string}, TContext> => {

const mutationKey = ['deleteVisitsVisitIdNotes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVisitsVisitIdNotes>>, {visitId: string}> = (props) => {
          const {visitId} = props ?? {};

          return  deleteVisitsVisitIdNotes(visitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVisitsVisitIdNotesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVisitsVisitIdNotes>>>
    
    export type DeleteVisitsVisitIdNotesMutationError = void | ErrorApiOutContract

    export const useDeleteVisitsVisitIdNotes = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdNotes>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVisitsVisitIdNotes>>,
        TError,
        {visitId: string},
        TContext
      > => {

      const mutationOptions = getDeleteVisitsVisitIdNotesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postVisitsVisitIdPatientinstructions = (
    visitId: string,
    messageApiContract: MessageApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<VisitMedicalRecordApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/patientinstructions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: messageApiContract, signal
    },
      options);
    }
  


export const getPostVisitsVisitIdPatientinstructionsMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdPatientinstructions>>, TError,{visitId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdPatientinstructions>>, TError,{visitId: string;data: MessageApiContract}, TContext> => {

const mutationKey = ['postVisitsVisitIdPatientinstructions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVisitsVisitIdPatientinstructions>>, {visitId: string;data: MessageApiContract}> = (props) => {
          const {visitId,data} = props ?? {};

          return  postVisitsVisitIdPatientinstructions(visitId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVisitsVisitIdPatientinstructionsMutationResult = NonNullable<Awaited<ReturnType<typeof postVisitsVisitIdPatientinstructions>>>
    export type PostVisitsVisitIdPatientinstructionsMutationBody = MessageApiContract
    export type PostVisitsVisitIdPatientinstructionsMutationError = void | ErrorApiOutContract

    export const usePostVisitsVisitIdPatientinstructions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdPatientinstructions>>, TError,{visitId: string;data: MessageApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVisitsVisitIdPatientinstructions>>,
        TError,
        {visitId: string;data: MessageApiContract},
        TContext
      > => {

      const mutationOptions = getPostVisitsVisitIdPatientinstructionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteVisitsVisitIdPatientinstructions = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/patientinstructions`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteVisitsVisitIdPatientinstructionsMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdPatientinstructions>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdPatientinstructions>>, TError,{visitId: string}, TContext> => {

const mutationKey = ['deleteVisitsVisitIdPatientinstructions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVisitsVisitIdPatientinstructions>>, {visitId: string}> = (props) => {
          const {visitId} = props ?? {};

          return  deleteVisitsVisitIdPatientinstructions(visitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVisitsVisitIdPatientinstructionsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVisitsVisitIdPatientinstructions>>>
    
    export type DeleteVisitsVisitIdPatientinstructionsMutationError = void | ErrorApiOutContract

    export const useDeleteVisitsVisitIdPatientinstructions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVisitsVisitIdPatientinstructions>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVisitsVisitIdPatientinstructions>>,
        TError,
        {visitId: string},
        TContext
      > => {

      const mutationOptions = getDeleteVisitsVisitIdPatientinstructionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postVisitsVisitIdIcdcodes = (
    visitId: string,
    visitIcdCodeCollectionDoctorApiInContract: VisitIcdCodeCollectionDoctorApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/icdcodes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: visitIcdCodeCollectionDoctorApiInContract, signal
    },
      options);
    }
  


export const getPostVisitsVisitIdIcdcodesMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdIcdcodes>>, TError,{visitId: string;data: VisitIcdCodeCollectionDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdIcdcodes>>, TError,{visitId: string;data: VisitIcdCodeCollectionDoctorApiInContract}, TContext> => {

const mutationKey = ['postVisitsVisitIdIcdcodes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVisitsVisitIdIcdcodes>>, {visitId: string;data: VisitIcdCodeCollectionDoctorApiInContract}> = (props) => {
          const {visitId,data} = props ?? {};

          return  postVisitsVisitIdIcdcodes(visitId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVisitsVisitIdIcdcodesMutationResult = NonNullable<Awaited<ReturnType<typeof postVisitsVisitIdIcdcodes>>>
    export type PostVisitsVisitIdIcdcodesMutationBody = VisitIcdCodeCollectionDoctorApiInContract
    export type PostVisitsVisitIdIcdcodesMutationError = void | ErrorApiOutContract

    export const usePostVisitsVisitIdIcdcodes = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdIcdcodes>>, TError,{visitId: string;data: VisitIcdCodeCollectionDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVisitsVisitIdIcdcodes>>,
        TError,
        {visitId: string;data: VisitIcdCodeCollectionDoctorApiInContract},
        TContext
      > => {

      const mutationOptions = getPostVisitsVisitIdIcdcodesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postVisitsVisitIdRatings = (
    visitId: string,
    visitRatingApiInContract: VisitRatingApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/ratings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: visitRatingApiInContract, signal
    },
      options);
    }
  


export const getPostVisitsVisitIdRatingsMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdRatings>>, TError,{visitId: string;data: VisitRatingApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdRatings>>, TError,{visitId: string;data: VisitRatingApiInContract}, TContext> => {

const mutationKey = ['postVisitsVisitIdRatings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVisitsVisitIdRatings>>, {visitId: string;data: VisitRatingApiInContract}> = (props) => {
          const {visitId,data} = props ?? {};

          return  postVisitsVisitIdRatings(visitId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVisitsVisitIdRatingsMutationResult = NonNullable<Awaited<ReturnType<typeof postVisitsVisitIdRatings>>>
    export type PostVisitsVisitIdRatingsMutationBody = VisitRatingApiInContract
    export type PostVisitsVisitIdRatingsMutationError = void | ErrorApiOutContract

    export const usePostVisitsVisitIdRatings = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdRatings>>, TError,{visitId: string;data: VisitRatingApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVisitsVisitIdRatings>>,
        TError,
        {visitId: string;data: VisitRatingApiInContract},
        TContext
      > => {

      const mutationOptions = getPostVisitsVisitIdRatingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    